/**
 * Utility functions for iframe scrolling in plugin checkout flow
 */

/**
 * Triggers parent window to scroll to iframe position
 * Only works when in iframe context (embedded in another site)
 *
 * @param {Object} options - Scroll configuration
 * @param {number} options.offset - Pixels from top (default: 100)
 * @param {boolean} options.smooth - Use smooth scrolling (default: true)
 */
export const triggerIframeScroll = (options = {}) => {
  // Only trigger if we're in an iframe context
  if (window.parent && window !== window.parent) {
    window.parent.postMessage(
      {
        context: 'plugins-v2',
        action: 'scroll_to_iframe',
        offset: options.offset || 100,
        smooth: options.smooth !== false, // default to true
      },
      '*'
    );
  }
};

/**
 * Triggers iframe scroll specifically for checkout step transitions
 * Uses optimized settings for mobile booking flow
 */
export const triggerCheckoutStepScroll = () => {
  triggerIframeScroll({
    offset: 100,
    smooth: true,
  });
};

/**
 * Triggers iframe scroll to center when Stripe 3DS modal opens
 * Centers the iframe in viewport so 3DS modal is visible
 */
export const triggerStripe3dsScroll = () => {
  // Only trigger if we're in an iframe context
  if (window.parent && window !== window.parent) {
    window.parent.postMessage(
      {
        context: 'plugins-v2',
        action: 'scroll_to_iframe_center',
      },
      '*'
    );
  }
};
